import { GoalsTrackingViewDto } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const goalsTrackingRequests = {
  getGoalsForMember: EndpointDefinition.get<
    GoalsTrackingViewDto,
    { memberId: string }
  >({
    name: 'getGoalsForMember',
    route: '/users/goals-tracking/:memberId',
  }),

  getGoalsForGuide: EndpointDefinition.get<
    GoalsTrackingViewDto[],
    { guideId: string }
  >({
    name: 'getGoalsForGuide',
    route: '/users/goals-tracking/guide/:guideId',
  }),
};
